import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

export const getMessagesData = createAsyncThunk(
  'conversations',
  (unreadMessages) => {
    return unreadMessages;
  }
);

const initialState = {
  loading: false,
  totalUnreadMessage: 0,
  error: null,
  success: false,
}

const messagesReducer = createSlice({
  name: 'messages',
  initialState,
  reducers: {},
  extraReducers:(builder) => {
    builder
    .addCase(getMessagesData.pending, (state) => {
      state.loading = true;
      state.totalUnreadMessage = 0;
      state.error = null;
      state.success = false;
    })
    .addCase(getMessagesData.fulfilled, (state, action) => {
      state.loading = false;
      state.totalUnreadMessage = action.payload ? action.payload : 0;
      state.error = null;
      state.success = true;
    })
    .addCase(getMessagesData.rejected, (state, action) => {
      state.loading = false;
      state.totalUnreadMessage = 0;
      if(action.error.message === 'Request failed with status code 401') {
        state.error = "Access Denied!, Invalid Credentials";
      } else {
        state.error = action.error.message;
      }
      state.success = false;
    })
  },
})

export default messagesReducer.reducer
